// Tooltip · Linear / macOS HIG tarzi; koyu yuzey, ince metin, subtle shadow.
const Tooltip = {
  baseStyle: {
    bg: 'gray.800',
    color: 'white',
    fontSize: 'xs',
    fontWeight: 'medium',
    borderRadius: 'md',
    boxShadow: 'lg',
    px: 3,
    py: 1.5,
    maxW: '280px',
    _dark: {
      bg: 'slate.800',
      color: 'white',
    },
  },
  defaultProps: {
    closeOnScroll: true,
    closeOnPointerDown: true,
    openDelay: 200,
    hasArrow: true,
  },
};

export default Tooltip;
